<template>
  <div class="whole">
    <m-header></m-header>
    <m-sidebar></m-sidebar>
    <div class="data-content">
      <div class="add-product">
        <el-form
          ref="form"
          :model="productForm"
          label-position="left"
          label-width="140px"
          size="mini"
        >
          <div class="product-title">商品类型</div>
          <el-radio-group
            v-model="productForm.type"
            size="small"
            style="padding-left: 10px;"
          >
            <el-radio border label="1">商城商品</el-radio>
            <el-radio border label="3">基础商品</el-radio>
            <el-radio border label="2">门店商品</el-radio>
          </el-radio-group>
          <el-form-item
            label="门店选择"
            v-show="productForm.type == 2"
            style="margin-top: 10px"
          >
            <el-select v-model="productForm.storeId">
              <el-option
                v-for="item in storeList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <div class="product-title">基本属性</div>
          <el-form-item label="商品名">
            <el-input v-model="productForm.name"></el-input>
          </el-form-item>
          <el-form-item label="副标题">
            <el-input v-model="productForm.subTitle"></el-input>
          </el-form-item>
          <el-form-item label="商品分类">
            <el-cascader
              v-model="categorySelect"
              :options="categoryOptions"
              @change="handleCategoryChange"
            >
            </el-cascader>
          </el-form-item>
          <el-form-item label="商品专区">
            <el-select v-model="productForm.prefectureIdList" multiple>
              <el-option
                v-for="item in prefectureOptions"
                :key="item.id"
                :label="item.title"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="关联品牌">
            <el-select v-model="productForm.brandId">
              <el-option
                v-for="item in brandCategoryCategoryOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="是否为自提商品">
            <el-radio-group v-model="productForm.isPurchase" size="small">
              <el-radio label="1">是</el-radio>
              <el-radio label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="是否进入进货区">
            <el-radio-group v-model="productForm.isRestock" size="small">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="最小进货数量">
            <el-input
              v-model="productForm.restockNum"
              placeholder="请输入最小进货量"
              style="float: none;width: 250px;"
            ></el-input>
          </el-form-item>
          <el-form-item label="商品类型">
            <el-radio-group v-model="productForm.isNumGoods" size="small">
              <el-radio :label="0">普通商品</el-radio>
              <el-radio :label="1">计次商品</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="计次商品单位数量" v-if="productForm.isNumGoods == 1">
            <el-input v-model.number="productForm.numGoodsUnit" placeholder="请输入单位数量" style="float: none;width: 250px;"></el-input>
            <span style="color: #999; font-size: 12px;">SKU商品次数必须为该数量的整数倍</span>
          </el-form-item>
          <el-form-item label="特殊商品">
            <el-radio-group v-model="productForm.isLevel" size="small">
              <el-radio label="1">是</el-radio>
              <el-radio label="0">否</el-radio> </el-radio-group
            >&nbsp;
            <el-input
              v-model="productForm.bonusRate"
              placeholder="分红比例(0~1)"
              style="float: none;width: 120px;"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item label="QT配额">
            <el-input v-model="productForm.qtRate" placeholder="请输入QT配额(0~1)" style="float: none;width: 250px;"></el-input>
          </el-form-item> -->
          <el-form-item label="用户QT配额">
            <el-input
              v-model="productForm.userQtRate"
              placeholder="请输入QT配额(0~1)"
              style="float: none;width: 250px;"
            ></el-input>
          </el-form-item>
          <el-form-item label="商品积分抵扣">
            <el-radio-group v-model="productForm.isPoints" size="small">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="一元购商品">
            <el-radio-group v-model="productForm.isOnePay" size="small">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="不结算市场管理奖">
            <el-radio-group v-model="productForm.isSubsidyRate" size="small">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="是否区域产品">
            <el-radio-group v-model="productForm.isRegion" size="small">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="是否团购产品">
            <el-radio-group v-model="productForm.isGroup" size="small">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="是否为消费礼包">
            <el-radio-group v-model="productForm.isGiftPkg" size="small">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="赠送积分比例">
            <el-input
              v-model="productForm.giveScoreRate"
              @input="limitGiveScoreRate"
              placeholder="请输入赠送积分比例(0~0.03)"
              style="float: none;width: 250px;"
            ></el-input>
          </el-form-item>
          <el-form-item label="是否开启链动">
            <el-radio-group v-model="productForm.isChain" size="small">
              <el-radio :label="1">开启</el-radio>
              <el-radio :label="0">关闭</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="配送地址" v-show="productForm.isRegion == 1">
            <el-select
              v-model="productForm.provinceCode"
              multiple
              placeholder="请选择省"
              @change="onChoiceProvince"
            >
              <el-option
                v-for="item in provinceList"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              ></el-option>
            </el-select>
            <el-select
              v-model="productForm.cityCode"
              multiple
              placeholder="请选择市"
              @change="onChoiceCity"
            >
              <el-option
                v-for="item in cityList"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              ></el-option>
            </el-select>
            <el-select
              v-model="productForm.countyCode"
              multiple
              placeholder="请选择区"
              @change="onChoiceCounty"
            >
              <el-option
                v-for="item in countyList"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              ></el-option>
            </el-select>
            <!-- <el-select
              v-model="productForm.streetCode"
              multiple
              placeholder="请选择街道"
              @change="onChoiceStreet"
            >
              <el-option
                v-for="item in streetList"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              ></el-option>
            </el-select> -->
          </el-form-item>
          <!-- 标题 -->
          <div class="product-title">商品规格</div>
          <el-form-item label="规格名称">
            <el-tag
              :key="i"
              v-for="(spec, i) in specialSpec"
              closable
              :disable-transitions="false"
              @close="handleClose(i)"
            >
              {{ spec.title }}
            </el-tag>
            <el-button class="button-new-tag" size="small" @click="showInput"
              >添加规格</el-button
            >
          </el-form-item>
          <el-form-item :key="i" v-for="(spec, i) in specialSpec">
            <label slot="label" style="margin-left: 10px;font-weight: 600;">{{
              spec.title
            }}</label>
            <el-tag
              :key="i"
              v-for="(content, i) in spec.option"
              closable
              :disable-transitions="false"
              @close="handleCloseOption(spec, i)"
            >
              {{ content }}
            </el-tag>
            <el-input
              v-model="spec.inputValue"
              style="float: none;width: 120px;"
            ></el-input>
            <el-button
              class="button-new-tag"
              size="small"
              @click="handleAddSpecOption(spec)"
              >添加</el-button
            >
          </el-form-item>
          <el-button
            style="width: 200px;"
            size="small"
            type="primary"
            @click="handleAddPrice()"
            >添加商品参数</el-button
          >
          <div class="product-title"></div>
          <el-table
            v-if="skuBos.length > 0"
            ref="multipleTable"
            :data="skuBos"
            tooltip-effect="dark"
            style="width: 95%"
            border
          >
            <el-table-column prop="title" label="商品名称" width="160">
            </el-table-column>
            <el-table-column
              prop="specialSpec"
              label="商品规格"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column prop="stock" label="库存" width="120">
            </el-table-column>
            <el-table-column prop="marketPrice" label="市场价" width="100">
            </el-table-column>
            <el-table-column prop="mallPrice" label="商城价" width="100">
            </el-table-column>
            <el-table-column prop="costPrice" label="成本价" width="100">
            </el-table-column>
            <el-table-column prop="settlementPrice" label="供货价" width="100">
            </el-table-column>
            <el-table-column
              prop="purchasePrice"
              label="门店进货价"
              width="120"
            >
            </el-table-column>
            <el-table-column
              prop="goodsNum"
              label="商品次数"
              width="100"
              v-if="productForm.isNumGoods == 1"
            >
            </el-table-column>
            <!-- <el-table-column
              prop="perPrice"
              label="单次价格"
              width="100"
              v-if="productForm.isNumGoods == 1"
            >
            </el-table-column> -->
            <el-table-column
              prop="perPrice"
              label="单次价格"
              width="100"
              v-if="productForm.isNumGoods == 1"
              :formatter="formatPrice"
            >
            </el-table-column>
            <!-- <el-table-column
              prop="uvalue"
              label="U值"
              width="100">
            </el-table-column> -->
            <el-table-column
              prop="enable"
              :formatter="handleEnableValue"
              label="是否在售"
              width="100"
            >
            </el-table-column>
            <el-table-column label="操作" width="150px">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="danger"
                  style="width: 50px;"
                  @click="handleDelete(scope.$index, scope.row)"
                  >移除</el-button
                >
                <el-button
                  size="mini"
                  style="width: 50px;"
                  @click="handleEdit(scope.$index, scope.row)"
                  >编辑</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <div class="product-title">
            QT配额<span class="graytit">(0~1)最多两位小数</span>
          </div>
          <el-table
            :data="qtPrices"
            tooltip-effect="dark"
            style="width: 95%"
            border
            :key="Math.random()"
          >
            <el-table-column prop="title" label="会员等级"
              >QT配额值</el-table-column
            >
            <el-table-column prop="qtRate" label="非会员">
              <template slot-scope="scope">
                <el-input
                  type="number"
                  v-model="productForm.qtRate"
                  style="width: 100%"
                  placeholder="请输入QT配额(0~1)"
                  @input="firstqtUpdateActive(productForm.qtRate)"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="qtOneRate" label="体验会员">
              <template slot-scope="scope">
                <el-input
                  type="number"
                  v-model="productForm.qtOneRate"
                  style="width: 100%"
                  placeholder="请输入QT配额(0~1)"
                  @blur="qtUpdateActive(productForm.qtOneRate)"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="qtTwoRate" label="vip会员">
              <template slot-scope="scope">
                <el-input
                  type="number"
                  v-model="productForm.qtTwoRate"
                  style="width: 100%"
                  placeholder="请输入QT配额(0~1)"
                  @blur="qtUpdateActive(productForm.qtTwoRate)"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="qtThreeRate" label="金牌会员">
              <template slot-scope="scope">
                <el-input
                  type="number"
                  v-model="productForm.qtThreeRate"
                  style="width: 100%"
                  placeholder="请输入QT配额(0~1)"
                  @blur="qtUpdateActive(productForm.qtThreeRate)"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="qtFourRate" label="钻石会员">
              <template slot-scope="scope">
                <el-input
                  type="number"
                  v-model="productForm.qtFourRate"
                  style="width: 100%"
                  placeholder="请输入QT配额(0~1)"
                  @blur="qtUpdateActive(productForm.qtFourRate)"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="price4" label="总代会员">
              <template slot-scope="scope">
                <el-input
                  type="number"
                  v-model="productForm.qtFiveRate"
                  style="width: 100%"
                  placeholder="请输入QT配额(0~1)"
                  @blur="qtUpdateActive(productForm.qtFiveRate)"
                ></el-input>
              </template>
            </el-table-column>
          </el-table>

          <div class="product-title">复消价格</div>
          <el-input
            v-model="active"
            style="width: 10%"
            class="activestyle"
            @blur="UpdateActive"
          ></el-input>
          <el-table
            v-if="(productForm.id && skuBos.length > 0) || skuBos.length == 0"
            ref="multipleTable"
            :data="fxPrices"
            tooltip-effect="dark"
            style="width: 95%"
            border
          >
            <el-table-column prop="title" label="商品名称"></el-table-column>
            <el-table-column prop="price" label="非会员" width="160">
              <template #default="scope">
                <!-- scope.row.price -->
                <el-input
                  type="number"
                  v-model="scope.row.price"
                  style="width: 100%"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="price0" label="体验会员" width="160">
              <template slot-scope="scope">
                <el-input
                  type="number"
                  v-model="scope.row.price0"
                  style="width: 100%"
                  @input="updateValues(scope)"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="price1" label="vip会员" width="160">
              <template slot-scope="scope">
                <el-input
                  type="number"
                  v-model="scope.row.price1"
                  style="width: 100%"
                  :value="updateValues1"
                  readonly
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="price2" label="金牌会员" width="160">
              <template slot-scope="scope">
                <el-input
                  type="number"
                  v-model="scope.row.price2"
                  style="width: 100%"
                  :value="updateValues2"
                  readonly
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="price3" label="钻石会员" width="160">
              <template slot-scope="scope">
                <el-input
                  type="number"
                  v-model="scope.row.price3"
                  style="width: 100%"
                  :value="updateValues3"
                  readonly
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="price4" label="总代会员" width="160">
              <template slot-scope="scope">
                <el-input
                  type="number"
                  v-model="scope.row.price4"
                  style="width: 100%"
                  :value="updateValues4"
                  readonly
                ></el-input>
              </template>
            </el-table-column>
          </el-table>
          <el-button
            size="small"
            type="primary"
            @click="onSaveFx"
            style="margin:10px auto;display: block"
            >保存复消价格
          </el-button>
          <el-form-item label="供应商选择">
            <el-select v-model="productForm.supplierId">
              <el-option
                v-for="item in supplierOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="物流">
            <el-select v-model="productForm.logisticsId">
              <el-option
                v-for="item in logisticsOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id"/>
            </el-select>
          </el-form-item> -->
          <el-form-item label="青禾优品推荐展示">
            <el-radio-group v-model="productForm.homePage" size="small">
              <el-radio label="1">是</el-radio>
              <el-radio label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="首页青禾商城展示">
            <el-radio-group v-model="productForm.newHomePage" size="small">
              <el-radio label="1">是</el-radio>
              <el-radio label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="是否支持退货">
            <el-radio-group v-model="productForm.exchange" size="small">
              <el-radio label="1">支持</el-radio>
              <el-radio label="0">不支持</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="是否支持调换">
            <el-radio-group v-model="productForm.refundable" size="small">
              <el-radio label="1">支持</el-radio>
              <el-radio label="0">不支持</el-radio>
            </el-radio-group>
          </el-form-item>
          <!-- 按钮 -->
          <el-button
            style="width: 200px;"
            size="small"
            type="primary"
            @click="handleAddProvince"
            >添加不包邮省份</el-button
          >
          <div class="product-title"></div>
          <!-- 不包邮省份表 -->
          <!-- <el-table>：表格组件的开始标签，通过 v-if="areaFees.length > 0" 来判断是否有数据，如果 areaFees 数组的长度大于 0，表格将被显示。
             ref="multipleTable"：为表格添加一个引用，以便后续可以通过引用访问表格的属性和方法。
            :data="areaFees"：将表格的数据绑定到 areaFees 数组，这是表格要显示的数据。
            tooltip-effect="dark"：当鼠标悬停在单元格上时，显示工具提示并使用深色效果。
            style="width: 80%"：设置表格的宽度为 80%。
            border：为表格添加边框。
          -->
          <el-table
            v-if="areaFees.length > 0"
            ref="multipleTable"
            :data="areaFees"
            tooltip-effect="dark"
            style="width: 80%"
            border
          >
            <!-- <el-table-column>：表格的列，每个 <el-table-column> 表示表格中的一列数据。
            prop="provinces"：这一列的数据来源是 provinces 属性。
            label="不包邮省份"：列的标题名称是“不包邮省份”。
            show-overflow-tooltip：当列内容溢出时，显示工具提示。-->
            <el-table-column
              prop="provinces"
              label="不包邮省份"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              label="规格"
              width="100"
              prop="specialSpecValue"
            ></el-table-column>
            <el-table-column prop="logisticsFee" label="运费" width="100">
            </el-table-column>
            <el-table-column label="操作" width="150px">
              <template slot-scope="scope">
                <!-- @click="handleDeleteProvince(scope.$index, scope.row)"：点击 "移除" 按钮时，触发 handleDeleteProvince 方法，传递当前行的索引和行数据作为参数。 -->
                <el-button
                  size="mini"
                  type="danger"
                  style="width: 50px;"
                  @click="handleDeleteProvince(scope.$index, scope.row)"
                  >移除</el-button
                >
                <el-button
                  size="mini"
                  style="width: 50px;"
                  @click="handleEditProvince(scope.$index, scope.row)"
                  >编辑
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="product-title">图片</div>
          <el-form-item label="主图">
            <el-upload
              action=""
              class="upload-demo"
              :http-request="uploadSectionFile"
              :on-remove="handleSectionRemove"
              :limit="100"
              :file-list="fileList"
              list-type="picture"
              accept="image/*,video/mp4"
            >
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
          </el-form-item>

          <el-form-item label="视频主图">
            <el-upload
              action=""
              class="upload-demo"
              :http-request="uploadVideoSectionFile"
              :on-remove="handleVideoSectionRemove"
              :limit="1"
              :file-list="fileList4"
              list-type="picture"
            >
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
          </el-form-item>
          <el-form-item label="视频">
            <el-upload
              action=""
              class="upload-demo"
              :http-request="uploadVideoUrlFile"
              :on-remove="handleVideoUrlRemove"
              :limit="1"
              :file-list="fileList3"
              list-type="video"
            >
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
          </el-form-item>
          <el-form-item label="商品详情图">
            <el-upload
              action=""
              class="upload-demo"
              :http-request="uploadManyFile"
              :on-remove="handleManyRemove"
              :limit="100"
              :file-list="fileList1"
              list-type="picture"
            >
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
          </el-form-item>
          <el-form-item label="是否参与销售收益">
            <el-radio-group v-model="productForm.isDistributor" size="small">
              <el-radio label="1">参与</el-radio>
              <el-radio label="0">不参与</el-radio>
            </el-radio-group>
          </el-form-item>
          <!--          <el-form-item label="体验分销比例" v-if="productForm.isDistributor=='1'">-->
          <!--            <el-input v-model="productForm.oneRate"></el-input>-->
          <!--          </el-form-item>-->
          <!--          <el-form-item label="金牌分销比例" v-if="productForm.isDistributor=='1'">-->
          <!--            <el-input v-model="productForm.twoRate"></el-input>-->
          <!--          </el-form-item>-->
          <!--          <el-form-item label="总代分销比例" v-if="productForm.isDistributor=='1'">-->
          <!--            <el-input v-model="productForm.threeRate"></el-input>-->
          <!--          </el-form-item>-->
          <!--          <el-form-item label="联创分销比例" v-if="productForm.isDistributor=='1'">-->
          <!--            <el-input v-model="productForm.fourRate"></el-input>-->
          <!--          </el-form-item>-->
          <!--          <el-form-item label="董事分销比例" v-if="productForm.isDistributor=='1'">-->
          <!--            <el-input v-model="productForm.fiveRate"></el-input>-->
          <!--          </el-form-item>-->
          <el-form-item
            label="一星销售收益比例"
            v-if="productForm.isDistributor == '1'"
          >
            <el-input v-model="productForm.oneRate"></el-input>
          </el-form-item>
          <el-form-item
            label="二星销售收益比例"
            v-if="productForm.isDistributor == '1'"
          >
            <el-input v-model="productForm.twoRate"></el-input>
          </el-form-item>
          <el-form-item
            label="三星销售收益比例"
            v-if="productForm.isDistributor == '1'"
          >
            <el-input v-model="productForm.threeRate"></el-input>
          </el-form-item>
          <el-form-item
            label="四星销售收益比例"
            v-if="productForm.isDistributor == '1'"
          >
            <el-input v-model="productForm.fourRate"></el-input>
          </el-form-item>
          <el-form-item
            label="五星销售收益比例"
            v-if="productForm.isDistributor == '1'"
          >
            <el-input v-model="productForm.fiveRate"></el-input>
          </el-form-item>

          <!--          不同级别销售收益比例-->
          <el-form-item label="二级一星销售收益比例" v-if="productForm.isDistributor == '1'">
            <el-input v-model="productForm.oneRate2"></el-input>
          </el-form-item>
          <el-form-item label="二级二星销售收益比例" v-if="productForm.isDistributor == '1'">
            <el-input v-model="productForm.twoRate2"></el-input>
          </el-form-item>
          <el-form-item label="二级三星销售收益比例" v-if="productForm.isDistributor == '1'">
            <el-input v-model="productForm.threeRate2"></el-input>
          </el-form-item>
          <el-form-item label="二级四星销售收益比例" v-if="productForm.isDistributor == '1'">
            <el-input v-model="productForm.fourRate2"></el-input>
          </el-form-item>
          <el-form-item label="二级五星销售收益比例" v-if="productForm.isDistributor == '1'">
            <el-input v-model="productForm.fiveRate2"></el-input>
          </el-form-item>
          <el-form-item size="large">
            <el-button type="primary" @click="onSubmit">提交</el-button>
            <el-button>取消</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- 添加规格 -->
      <el-dialog
        title="添加规格"
        :visible.sync="inputVisible"
        :append-to-body="true"
        width="30%"
        :modal="false"
      >
        <el-form label-position="left" label-width="80px">
          <el-form-item label="规格名称:">
            <el-input v-model="inputValue"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="inputVisible = false">取 消</el-button>
          <el-button type="primary" @click="handleInputConfirm"
            >确 定</el-button
          >
        </div>
      </el-dialog>
      <!-- 添加商品参数 -->
      <el-dialog
        title="添加商品参数"
        :visible.sync="priceVisible"
        :append-to-body="true"
        width="50%"
        :modal="false"
      >
        <el-form label-position="left" label-width="100px">
          <el-form-item label="商品名称">
            <el-input v-model="singleProduct.title"></el-input>
          </el-form-item>
          <el-form-item label="权重积分比例">
            <el-input v-model="singleProduct.scoreRate"></el-input>
          </el-form-item>
          <el-form-item label="权重分红池计算比例">
            <el-input v-model="singleProduct.weightRate"></el-input>
          </el-form-item>
          <el-form-item label="调节池比例">
            <el-input v-model="singleProduct.adjustRate"></el-input>
          </el-form-item>
          <el-form-item label="贡献值费率">
            <el-input v-model="singleProduct.contributionRate"></el-input>
          </el-form-item>
          <el-form-item :key="i" v-for="(spec, i) in specialSpec">
            <label slot="label" style="margin-left: 10px;font-weight: 600;">{{
              spec.title
            }}</label>
            <el-select v-model="selectSpec[i]">
              <el-option
                v-for="content in spec.option"
                :key="content"
                :label="content"
                :value="content"
              />
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="基础商品关联">
            <el-select v-model="singleProduct.baseSkuId">
              <el-option
                v-for="item in baseGoodsList"
                :key="item.id"
                :label="item.title + item.specialSpec"
                :value="item.id"
              />
            </el-select>
          </el-form-item> -->
          <el-form-item label="是否为基础产品">
            <el-radio-group v-model="singleProduct.isBaseSku" size="small">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="商品关联数量">
            <el-input v-model="singleProduct.baseNumber"></el-input>
          </el-form-item>
          <el-form-item label="商品条形码">
            <el-input
              v-model="singleProduct.barCode"
              @blur="handleBarcodeInput"
              placeholder="请输入商品条形码(1.先点击输入框 2.扫码枪扫描商品条形码)"
            ></el-input>
          </el-form-item>
          <el-form-item label="库存">
            <el-input v-model="singleProduct.stock"></el-input>
          </el-form-item>
          <!--          <el-form-item label="赠送期权积分比例，取值范围[0-1]">-->
          <!--            <el-input v-model="singleProduct.stockRights"></el-input>-->
          <!--          </el-form-item>-->
          <el-form-item label="市场价">
            <el-input v-model="singleProduct.marketPrice"></el-input>
          </el-form-item>
          <el-form-item label="商城价">
            <el-input v-model="singleProduct.mallPrice"></el-input>
          </el-form-item>
          <el-form-item label="成本价">
            <el-input v-model="singleProduct.costPrice"></el-input>
          </el-form-item>
          <el-form-item label="供货商结算价">
            <el-input v-model="singleProduct.settlementPrice"></el-input>
          </el-form-item>
          <el-form-item label="门店进货价">
            <el-input v-model="singleProduct.purchasePrice"></el-input>
          </el-form-item>

          <el-form-item label="商品次数" v-if="productForm.isNumGoods == 1">
            <el-input v-model="singleProduct.goodsNum"></el-input>
          </el-form-item>
          <el-form-item label="单次价格" v-if="productForm.isNumGoods == 1">
            <el-input v-model="singleProduct.perPrice"></el-input>
          </el-form-item>
          <!-- <el-form-item label="赠送U值">
            <el-input v-model="singleProduct.uvalue"></el-input>
          </el-form-item> -->
          <el-form-item label="是否在售">
            <el-radio-group v-model="singleProduct.enable">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="商品图">
            <el-upload
              action=""
              class="upload-demo"
              :http-request="uploadSingleProductFile"
              :on-remove="handleImgRemove"
              :limit="100"
              :file-list="fileList2"
              list-type="picture"
            >
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="priceVisible = false">取 消</el-button>
          <el-button type="primary" @click="handleProductAdd">确 定</el-button>
        </div>
      </el-dialog>
      <!-- 添加不包邮省份 -->
      <!-- 这是 Element UI 的模态框组件。它用于创建一个弹出对话框。 -->
      <!-- title：对话框的标题，设置为 "添加不包邮省份"。 -->
      <!-- :visible.sync="provinceVisible"：使用 provinceVisible 变量控制对话框的显示和隐藏   :visible.sync 表示双向绑定，通过改变 provinceVisible 的值来控制对话框的显示状态。-->
      <!-- :append-to-body="true"：将对话框的内容追加到 body 元素上，这通常用于处理模态框的定位和样式。这个属性将模态框的定位从原本的相对于当前组件的位置变为相对于整个页面的位置。具体效果是模态框会出现在页面的正中央，而不再受当前组件的布局影响。 -->
      <!-- :modal="false"：设置模态框的遮罩层，这里设置为 false 表示没有遮罩层。 -->
      <el-dialog
        title="添加不包邮省份"
        :visible.sync="provinceVisible"
        :append-to-body="true"
        width="30%"
        :modal="true"
      >
        <!-- <el-form>：这是 Element UI 的表单组件，用于包含表单元素。 label-position：标签位置设置为 "left"，即标签位于左侧。 label-width：标签的宽度设置为 "100px"。 -->
        <el-form label-position="left" label-width="100px">
          <!-- <el-form-item>：表单项，包含表单字段和标签。label：标签显示的文本，这里设置为 "不包邮省份"。 -->
          <el-form-item label="规格">
            <!-- <el-select>：多选下拉选择框组件，用于选择不包邮的省份。 v-model 指令将其与组件的 singleProvince.specialSpecValue 属性进行双向数据绑定。这意味着当用户选择了一个规格，选择的值将自动更新到 singleProvince.specialSpecValue 中，反之亦然。-->
            <el-select v-model="singleProvince.specialSpecValue">
              <el-option
                v-for="item in specifications"
                :key="item"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="不包邮省份">
            <el-select multiple v-model="singleProvince.codes">
              <!-- (<el-option>) 元素，用于展示可供选择的规格。它是通过一个 v-for 循环遍历 specifications 数组中的每个元素来动态生成的。 -->
              <el-option
                v-for="item in provinceOptions"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="邮费">
            <!-- <el-input>：输入框组件，用于输入邮费。 -->
            <el-input v-model="singleProvince.logisticsFee"></el-input>
          </el-form-item>
        </el-form>
        <!-- <div slot="footer" class="dialog-footer">：底部的操作按钮区域。 -->
        <div slot="footer" class="dialog-footer">
          <!-- <el-button @click="provinceVisible = false">取 消：取消按钮，点击后将 provinceVisible 设置为 false，从而隐藏对话框。 -->
          <el-button @click="provinceVisible = false">取 消</el-button>
          <!-- <el-button type="primary" @click="handleProvinceAdd">确 定：确定按钮，点击后触发 handleProvinceAdd 方法，用于执行添加不包邮省份的操作。 -->
          <el-button type="primary" @click="handleProvinceAdd">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { Loading } from "element-ui";
import MSidebar from "components/header/sidebar";
import MHeader from "components/header/header";
import {
  postRepeatPrice,
  getStoreList,
  getCategorys,
  getAllSupplier,
  getLogistics,
  getAllProvince,
  getProductDetail, //要修改的和运费有关的一个东西
  updateProduct,
  addProduct,
  uploadFile1,
  productSkuList,
  cityList,
  getPrefecture, //商品专区的选择列表
  brandCategoryCategory //关联品牌的选择列表
} from "api/request";
import { ERR_OK } from "api/config";
import { loadingInstance, Success, Error } from "common/js/util";
export default {
  components: {
    MSidebar,
    MHeader
  },
  data() {
    return {
      index: "",
      price: "",
      price0: 0,
      price1: 0,
      price2: 0,
      price3: 0,
      price4: 0,
      active: 0,
      productId: null,
      priceStatus: 1,
      provinceStatus: 1,
      fileList: [],
      fileList1: [],
      fileList2: [],
      fileList3: [], //视频
      fileList4: [], //视频主图
      categorySelect: [],
      prefectureSelect: [],
      prefectureOptions: [], //商品专区
      brandCategoryCategoryOptions: [], //关联品牌
      categoryOptions: [],
      provinceOptions: [],
      options1: [],
      inputVisible: false,
      inputValue: "",
      priceVisible: false,
      provinceVisible: false,
      specialSpec: [],
      skuBos: [],
      areaFees: [],
      selectSpec: [],
      singleProvince: {},
      singleProduct: {
        isBaseSku: 0, //是否为基础产品
        baseNumber: 1 // 初始时 '商品关联数量' 设置为 1
      },
      copyIndex: 0,
      removeIds: [],
      specOptions: [],
      supplierOptions: [],
      logisticsOptions: [],
      productForm: {
        giveScoreRate:0,//赠送积分比例
        oneRate2:"",	//二级一星销售收益比例
        twoRate2:"",	//二级二星销售收益比例
        threeRate2:"",	//二级三星销售收益比例
        fourRate2:"",	//二级四星销售收益比例
        fiveRate2:"",	//二级五星销售收益比例
        isChain:0,  //是否开启链动  1开启  0关闭
        video: null, //上传视频
        videoImage: null, //上传视频主图
        qtRate: "",
        qtOneRate: "",
        qtTwoRate: "",
        qtThreeRate: "",
        qtFourRate: "",
        qtFiveRate: "",
        storeId: null,
        type: 1,
        name: "",
        subTitle: "",
        cid1: "",
        cid2: "",
        prefectureIdList: [], //商品专区
        brandId: "", //关联品牌
        homePage: "1",
        newHomePage: "0",
        isPurchase: "0", //是否为自提商品
        isNumGoods: 0,
        numGoodsUnit: 0, // 计次商品单位数量
        exchange: "1",
        refundable: "1",
        isDistributor: "0",
        codes: [],
        brandId: null,
        supplierId: null,
        logisticsId: null,
        specialSpec: [],
        // type: [],
        masterImage1: [],
        detailsImages: [],
        isLevel: "0",
        isRestock: 0, //是否进入进货区
        isPoints: 0, //商品积分抵扣
        isOnePay: 0, //一元购商品
        isRegion: 0, //是否区域产品
        isGroup:0,//是否团购商品
        isGiftPkg: 0, //是否为消费礼包
        isSubsidyRate: 0, //不结算市场管理奖

        // provinceCode: null, //省
        // cityCode: null,   //市
        // countyCode: null,  //区
        // 初始化为数组
        provinceCode: [], //配送地址的省code
        cityCode: [], //配送地址的市code
        countyCode: [], //配送地址的区code
        streetCode: [], //配送地址的街道code
        province: null, //配送地址的省名称
        city: null, //配送地址的省名称
        county: null, //配送地址的省名称
        street: "" //配送地址的省名称
      },
      storeList: [],
      fxPrices: [],
      qtPrices: [0],
      // 规格
      specifications: [],
      baseGoodsList: [],
      provinceList: [],
      cityList: [],
      countyList: [],
      streetList: []
    };
  },
  // watch: {
  //   "singleProduct.perPrice": function(newVal) {
  //     if (typeof newVal === "number") {
  //       this.singleProduct.perPrice = parseFloat(newVal).toFixed(2);
  //     }
  //   }
  // },
  mounted() {
    let getUserInfo = JSON.parse(window.localStorage.getItem("getUserInfo"));
    if (!getUserInfo) {
      this.$router.push({
        path: "/"
      });
    } else {
      this.fileyHeader = {
        token: getUserInfo.token,
        "Content-Type": "multipart/form-data"
      };
      this.productId = this.$route.query.productId;
      this._getCategory();
      this._getSupplier();
      this._getLogistics();
      this._getProvince();
      this._getStoreList();
      this._productSkuList();
      this._getProvinceList("0");
      this.getPrefecture(); //商品专区的选择列表
      this.brandCategoryCategory(); //关联品牌的选择列表
    }
  },

  methods: {
    // 限制输入框最大输入的值
    limitGiveScoreRate(value){
      // 将输入值转换为数字
      const numValue = Number(value);
      // 如果输入值是数字，并且大于3，则设置为3
      if (!isNaN(numValue) && numValue > 0.03) {
        this.productForm.giveScoreRate = 0.03;
      } else if (numValue < 0) {
        // 如果输入值是负数，则设置为0
        this.productForm.giveScoreRate = 0;
      }
    },
    // 输入框扫码枪输入商品条形码
    handleBarcodeInput() {
      // 这里处理扫码输入后的逻辑
      // console.log("扫描的条形码为:", this.singleProduct.barCode);
      // 例如，你可以根据扫码结果来验证条形码或更新其他相关数据
    },
    formatPrice(row, column) {
      let value = row[column.property];
      if (typeof value === "number") {
        return parseFloat(value).toFixed(2);
      }
      return value;
    },
    UpdateActive() {
      if (this.active < 1 || this.active > 15) {
        // setTimeout(()=>{
        this.$message("请输入1-15的值");
        this.active = "";
        // },1500)
      }
    },
    qtUpdateActive(data) {
      // console.log(data);
      let reg = /^0\.[1-9]{0,2}$/;
      if (!reg.test(data) && data != "" && data != 1 && data != 0) {
        setTimeout(() => {
          this.$message("请输入0-1的值(最多两位小数)");
        }, 500);
      }
    },
    firstqtUpdateActive() {
      this.productForm.qtOneRate = this.qtupdateValues1;
      this.productForm.qtTwoRate = this.qtupdateValues2;
      this.productForm.qtThreeRate = this.qtupdateValues3;
      this.productForm.qtFourRate = this.qtupdateValues4;
      this.productForm.qtFiveRate = this.qtupdateValues5;
      // console.log(this.productForm);
    },
    updateValues(scope) {
      (this.index = scope.$index),
        (this.fxPrices[scope.$index].price1 = this.updateValues1(
          this.fxPrices[scope.$index].price0
        ));
      this.fxPrices[scope.$index].price2 = this.updateValues1(
        this.fxPrices[scope.$index].price1
      );
      this.fxPrices[scope.$index].price3 = this.updateValues1(
        this.fxPrices[scope.$index].price2
      );
      this.fxPrices[scope.$index].price4 = this.updateValues1(
        this.fxPrices[scope.$index].price3
      );
      // 更新第二个输入框的值
      // this.price1 = this.updateValues1;
      // this.price2 = this.updateValues2;
      // this.price3 = this.updateValues3;
      // this.price4 = this.updateValues4;
    },
    getActive() {
      this.$message(this.active);
    },
    onSaveFx() {
      // console.log(this.fxPrices);
      let result = this.fxPrices.map(f => {
        let price = f.price || 0;
        let price0 = f.price0 || 0;
        let price1 = f.price1 || 0;
        let price2 = f.price2 || 0;
        let price3 = f.price3 || 0;
        let price4 = f.price4 || 0;
        return {
          skuId: f.skuId,
          prices: [price, price0, price1, price2, price3, price4]
        };
      });
      loadingInstance(Loading);
      postRepeatPrice(result).then(res => {
        loadingInstance(Loading).close();
        if (res.status === ERR_OK) {
        } else {
          Error(this, res);
        }
      });
    },
    // 请选择省
    // onChoiceProvince(code) {
    //   this.productForm.cityCode = this.productForm.countyCode = this.productForm.streetCode = null;
    //   this.provinceList.map(item => {
    //     if (item.code == code) {
    //       this.productForm.province = item.name;
    //     }
    //   });

    //   this._getCityList(code);
    // },
    onChoiceProvince(code) {
      this.productForm.cityCode = this.productForm.countyCode = null;
      this.productForm.province = code
        // this.provinceList.forEach(item => {
        //   if (item.code == code) {
        //     this.productForm.province = item.name;
        //   }
        // });
        .map(code => {
          const item = this.provinceList.find(item => item.code === code);
          return item ? item.name : "";
        })
        .join(",");

      this._getCityList(code);
    },
    // 请选择市
    // onChoiceCity(code) {
    //   this.productForm.countyCode = this.productForm.streetCode = null;

    //   this.cityList.map(item => {
    //     if (item.code == code) {
    //       this.productForm.city = item.name;
    //     }
    //   });
    //   this._getCountyList(code);
    // },
    onChoiceCity(selectedCityCodes) {
      this.productForm.countyCode = null;
      this.productForm.city = selectedCityCodes
        .map(code => {
          const item = this.cityList.find(item => item.code === code);
          return item ? item.name : "";
        })
        .join(",");

      this._getCountyList(selectedCityCodes);
    },
    // 请选择区
    // onChoiceCounty(code) {
    //   this.productForm.streetCode = null;
    //   this.countyList.map(item => {
    //     if (item.code == code) {
    //       this.productForm.county = item.name;
    //     }
    //   });
    //   this._getStreetList(code);
    // },
    onChoiceCounty(selectedCountyCodes) {
      this.productForm.county = selectedCountyCodes
        .map(code => {
          const item = this.countyList.find(item => item.code === code);
          return item ? item.name : "";
        })
        .join(",");
    },
    // // 选择街道
    // onChoiceStreet(codeList) {
    //   this.productForm.street = "";
    //   this.$forceUpdate();
    //   this.streetList.map(item => {
    //     for (var i = 0; i < codeList.length; i++) {
    //       if (item.code == codeList[i]) {
    //         this.productForm.street = this.productForm.street + "," + item.name;
    //       }
    //     }
    //   });
    //   // console.log(codeList.toString());
    //   // console.log(this.productForm.street);
    // },
    //获取省份
    _getProvinceList(code) {
      getAllProvince({
        pcode: code
      }).then(res => {
        if (res.status === ERR_OK) {
          this.provinceList = res.data;
        } else {
          Error(this, res);
        }
      });
    },
    //获取市
    // _getCityList(code) {
    //   getAllProvince({
    //     pcode: code
    //   }).then(res => {
    //     if (res.status === ERR_OK) {
    //       this.cityList = res.data;
    //     } else {
    //       Error(this, res);
    //     }
    //   });
    // },
    _getCityList(code) {
      const pcodeParam = code.join(",");
      // console.log("获取城市列表的省份代码:", code);
      getAllProvince({ pcode: pcodeParam }).then(res => {
        // console.log("返回的城市数据:", res);
        if (res.status === ERR_OK) {
          this.cityList = res.data;
        } else {
          Error(this, res);
        }
      });
    },
    //获取区
    // _getCountyList(code) {
    //   getAllProvince({
    //     pcode: code
    //   }).then(res => {
    //     if (res.status === ERR_OK) {
    //       this.countyList = res.data;
    //     } else {
    //       Error(this, res);
    //     }
    //   });
    // },
    _getCountyList(selectedCityCodes) {
      // console.log("获取区县列表的城市代码:", selectedCityCodes);
      this.countyList = [];
      let promises = selectedCityCodes.map(cityCode => {
        return getAllProvince({ pcode: cityCode }).then(res => {
          // console.log("单个城市下的区县数据:", res);
          if (res.status === ERR_OK) {
            return res.data;
          } else {
            Error(this, res);
            return [];
          }
        });
      });

      Promise.all(promises).then(allCounties => {
        this.countyList = allCounties.flat();
        // console.log("所有选中城市的区县数据合并后:", allCounties.flat());
      });
    },
    // //获取街道
    // _getStreetList(code) {
    //   getAllProvince({
    //     pcode: code
    //   }).then(res => {
    //     if (res.status === ERR_OK) {
    //       this.streetList = res.data;
    //     } else {
    //       Error(this, res);
    //     }
    //   });
    // },
    handleCategoryChange(value) {
      this.productForm.cid1 = value[0];
      if (value.length > 1) {
        this.productForm.cid2 = value[1];
      }
    },
    handlePrefectureChange(value) {
      this.productForm.cid1 = value[0];
      if (value.length > 1) {
        this.productForm.cid2 = value[1];
      }
    },
    handleProductAdd() {
      if (
        this.productForm.isPurchase == 1 &&
        !this.singleProduct.purchasePrice
      ) {
        alert("门店进货价不能为空");
        return;
      }
      // // 验证商品关联数量为非0且大于0的整数
      // if (!this.isPositiveInteger(this.singleProduct.baseNumber)) {
      //   alert("商品关联数量必须是非0且大于0的整数");
      //   return;
      // }
      this.singleProduct.specialSpec = this.selectSpec.toString();
      var copyProduct = JSON.parse(JSON.stringify(this.singleProduct));

      copyProduct.goodsNum = parseInt(copyProduct.goodsNum);
      // copyProduct.perPrice = parseInt(copyProduct.perPrice);
      // copyProduct.perPrice = parseFloat(copyProduct.perPrice).toFixed(2);
      // console.log(this.singleProduct);
      if (this.priceStatus == 1) {
        this.skuBos.push(copyProduct);
      } else {
        this.skuBos = this.skuBos.map((item, idx) => {
          if (idx == this.copyIndex) item = copyProduct;
          return item;
        });
      }
      // if(!copyProduct.id && !copyProduct._key){
      //   copyProduct._key = Math.random();
      //   this.skuBos.push(copyProduct);
      // }else{
      //
      //   this.skuBos = this.skuBos.map(item=>{
      //     if((item.id&&item.id == copyProduct.id) || (item._key&&item._key == copyProduct._key)) item = copyProduct;
      //     return item;
      //   })
      // }
      this.priceVisible = false;
    },
    // // 验证是否为非0且大于0的整数的函数
    // isPositiveInteger(value) {
    //   const number = parseInt(value, 10);
    //   return Number.isInteger(number) && number > 0;
    // },
    // 添加不包邮
    handleProvinceAdd() {
      // 如果存在规格，再把规格数据加到商品信息中
      if (this.singleProvince.specialSpecValue) {
        let a = [];
        this.skuBos.forEach(item => {
          // specialSpec 这是商品规格的意思
          // 它遍历 this.skuBos 数组，查找具有相同特殊规格的商品，然后将当前不包邮的省份信息 this.singleProvince 添加到这些商品的 areaFees 属性中。如果该商品的 areaFees 为空，它会创建一个新数组 a，将不包邮信息添加到其中，然后将 a 赋给 item.areaFees。
          if (item.specialSpec == this.singleProvince.specialSpecValue) {
            if (item.areaFees !== null && item.areaFees !== undefined) {
              item.areaFees.push(this.singleProvince);
            } else {
              a.push(this.singleProvince);
              item.areaFees = a;
            }
          }
        });
      }
      //  转换
      // 将用户选择的不包邮省份的代码（this.singleProvince.codes）转换为省份名称，并将其存储在 this.singleProvince.provinces 中，以便在后续的处理中显示。
      // this.singleProvince.codes 是一个数组，包含了一组省份的编码。
      this.singleProvince.provinces = this.singleProvince.codes
        .map((item, idx) => {
          //.map((item, idx) => { ... }) 是一个数组的遍历方法，用来将 this.singleProvince.codes 中的每个省份编码映射为省份名称。
          var value = this.provinceOptions.find(function(ele, index) {
            //在 .map 方法中，通过 var value = this.provinceOptions.find(...) 查找与当前省份编码匹配的 this.provinceOptions 中的对象，从中获取省份名称。
            return ele.code == item;
          });
          return value.name; //return value.name 返回找到的省份名称，这个结果构成了新的数组。
        })
        .toString(); //最后，.toString() 方法将这个新数组的元素用逗号连接成一个字符串，将其赋值给 this.singleProvince.provinces，这样就形成了一个用逗号分隔的省份名称列表。
      //
      var copyProvince = JSON.parse(JSON.stringify(this.singleProvince)); //这里创建了一个深拷贝的 copyProvince，以便稍后在添加或更新不包邮信息时不影响原始
      // console.log(copyProvince);
      if (this.provinceStatus == 1) {
        this.areaFees.push(copyProvince);
      } else {
        this.areaFees = this.areaFees.map((item, idx) => {
          // console.log(item);
          if (idx == this.copyIndex) item = copyProvince;
          return item;
        });
      }
      this.provinceVisible = false;
    },
    handleClose(i) {
      this.specialSpec.splice(i, 1);
    },
    //编辑商品参数
    handleEdit(index, row) {
      this.copyIndex = index;
      this.singleProduct = JSON.parse(JSON.stringify(row));
      this.priceStatus = 2;
      this.priceVisible = true;
      this.selectSpec = row.specialSpec.split(",");
      this.fileList2 = row.images.map(item => {
        // let url = "https://qy-static.umeng.top/file/";
        let url = "";
        let imgUrl = item.indexOf(url) == -1 ? url + item : item;
        return {
          name: imgUrl,
          url: imgUrl
        };
      });
    },

    // handleEdit(index, row) {
    //   this.copyIndex = index;
    //   this.singleProduct = JSON.parse(JSON.stringify(row));
    //   this.priceStatus = 2;
    //   this.priceVisible = true;
    //   this.selectSpec = row.specialSpec.split(",");
    //   this.fileList2 = row.images.map(item => {
    //     let url = "https://qy-static.umeng.top/file/";
    //     let imgUrl = item.indexOf(url) == -1 ? url + item : item;
    //     return {
    //       name: imgUrl.split("/").pop(), // 可能需要修改以获取正确的文件名
    //       url: imgUrl, // 确保这是一个可以访问的完整URL
    //       // 可能还需要添加其他属性，如 'status' 和 'uid'
    //       status: "success" // 可选，标记图片已上传
    //     };
    //   });
    // },
    //编辑不包邮
    handleEditProvince(index, row) {
      this.copyIndex = index;
      this.singleProvince = JSON.parse(JSON.stringify(row));
      this.provinceStatus = 2;
      this.provinceVisible = true;
    },
    // handleImgRemove(file, fileList) {
    //   this.singleProduct.images = fileList;
    // },
    handleImgRemove(file, fileList) {
      this.singleProduct.images = fileList.map(f => f.url || f.name);
    },
    handleDelete(index, row) {
      if (this.skuBos[index].id) {
        this.removeIds.push(this.skuBos[index].id);
      }
      this.skuBos.splice(index, 1);
    },
    // 删除
    handleDeleteProvince(index, row) {
      if (this.areaFees[index].id) {
        this.removeIds.push(this.areaFees[index].id);
      }
      this.areaFees.splice(index, 1);
      // 如果这个数据有规格，则删除规格中的这条数据
      if (
        row.hasOwnProperty("specialSpecValue") == true &&
        row.specialSpecValue !== null
      ) {
        if (this.skuBos !== null) {
          this.skuBos.forEach((item, index) => {
            let b = [];
            item.areaFees.forEach((i, d) => {
              // console.log("bbb");
              if (
                row.specialSpecValue == i.specialSpecValue &&
                row.logisticsFee == i.logisticsFee &&
                row.provinces == i.provinces
              ) {
                b.push({ index, d }); // 之前的写法会一次存两个值进数组
              }
            });
            // console.log("b------", b);
            for (var i = b.length - 1; i >= 0; i--) {
              item.areaFees.splice(b[i].d, 1); // 之前的写法在这里会导致删除两次，因为数组里有两个值
            }
          });
        }
      }
    },
    showInput() {
      this.inputVisible = true;
      this.inputValue = "";
    },
    handleInputConfirm() {
      let spec = {
        title: this.inputValue
      };
      if (this.inputValue) {
        this.specialSpec.push(spec);
      }
      this.inputVisible = false;
      this.inputValue = "";
    },
    handleCloseOption(spec, i) {
      spec.option.splice(i, 1);
      spec.inputValue = " ";
      spec.inputValue = "";
    },
    handleAddSpecOption(spec) {
      if (spec.option == null) {
        spec.option = new Array();
      }
      if (spec.inputValue) {
        spec.option.push(spec.inputValue);
        spec.inputValue = "";
      } else {
        alert("规格属性不能为空");
      }
    },
    handleAddPrice() {
      this.priceStatus = 1;
      this.priceVisible = true;
      this.singleProduct = {
        isBaseSku: 0, // 设置 "否" 为默认选项
        baseNumber: 1 // 初始时 '商品关联数量' 设置为 1
      };
      this.selectSpec = [];
      this.fileList2 = [];
      if (!this.singleProduct.images) {
        this.singleProduct.images = [];
      }
    },
    // 点击新增不包邮按钮
    //这段代码的目的是在用户点击 "新增不包邮" 按钮时，打开一个模态窗口，重置一些相关的状态，然后从 this.skuBos 中提取 "specialSpec" 数据并存储在 this.specifications 中，以供后续使用。这可能是与商品规格或其他参数相关的操作。
    handleAddProvince() {
      this.provinceStatus = 1; //设置了 provinceStatus 为 1          ，表示某种状态或标志
      this.provinceVisible = true; // 将 provinceVisible 设置为 true         ，表示打开模态框（即显示模态框）
      this.singleProvince = {}; //singleProvince 初始化为空对象。
      // 获取表格数据,重新制造数据
      // 从商品参数取到规格参数
      if (this.skuBos) {
        let a = [];
        this.skuBos.forEach(v => {
          //通过遍历 this.skuBos 数组中的每个元素，提取其中的 "specialSpec" 属性，并将其存储在数组 a 中。
          //外部循环使用 this.skuBos.forEach(v => {...}) 迭代 skuBos 数组中的元素。对于 skuBos 数组中的每个元素 v，都有一个内部循环：内部循环使用 for...in 循环迭代对象 v 的属性（键）。if 语句检查当前属性（由 atb 表示）是否等于字符串 "specialSpec"。如果属性是 "specialSpec"，则将该属性的值（v[atb]）添加到数组 a 中。
          for (let atb in v) {
            if (atb == "specialSpec") {
              a.push(v[atb]);
            }
          }
        }); //将 a 数组中的内容赋值给 this.specifications，以重新制造数据，存储商品的规格参数。
        this.specifications = a; //从 this.skuBos 中提取 "specialSpec" 数据并存储在 this.specifications 中，以供后续使用。
      }
    },
    handleEnableValue(row) {
      if (row.enable == 1) {
        return "在售";
      } else {
        return "下架";
      }
    },
    // handleSectionRemove(file, fileList) {
    //   if (fileList.length == 0) {
    //     this.productForm.masterImage = "";
    //   }
    // },
    // 删除主图
    handleSectionRemove(file, fileList) {
      this.productForm.masterImage1 = [];
      if (fileList.length > 0) {
        for (var i = 0; i < fileList.length; i++) {
          this.productForm.masterImage1.push(fileList[i].url);
        }
      }
    },
    handleManyRemove(file, fileList) {
      this.productForm.detailsImages = [];
      if (fileList.length > 0) {
        for (var i = 0; i < fileList.length; i++) {
          this.productForm.detailsImages.push(fileList[i].url);
        }
      }
    },
    //上传主图视频的背景图
    // 上传视频主图
    uploadVideoSectionFile(param) {
      var fileObj = param.file;
      var form = new FormData();
      form.append("file", fileObj);
      form.append("type", 401);
      uploadFile1(form).then(res => {
        loadingInstance(Loading).close();
        if (res.status === 200) {
          this.productForm.videoImage = res.data;
          // this.fileList = [{url: this.beforeUrl+res.data}];
        } else {
          Error(this, res);
        }
      });
    },
    //删除视频主图
    handleVideoSectionRemove(file, fileList) {
      if (fileList.length == 0) {
        this.productForm.videoImage = "";
      }
    },
    // 上传视频
    uploadVideoUrlFile(param) {
      var fileObj = param.file;
      var form = new FormData();
      form.append("file", fileObj);
      form.append("type", 402);
      uploadFile1(form).then(res => {
        loadingInstance(Loading).close();
        if (res.status === 200) {
          this.productForm.video = res.data;
          // this.fileList1 = [{ url: this.beforeUrl + res.data }];
        } else {
          Error(this, res);
        }
      });
    },
    //删除视频
    handleVideoUrlRemove(file, fileList) {
      if (fileList.length == 0) {
        this.productForm.video = "";
      }
    },
    // uploadSectionFile(param) {
    //   var fileObj = param.file;
    //   var form = new FormData();
    //   form.append("file", fileObj);
    //   form.append("type", 101);
    //   uploadFile1(form).then(res => {
    //     loadingInstance(Loading).close();
    //     if (res.status === ERR_OK) {
    //       this.productForm.masterImage = res.data;
    //     } else {
    //       Error(this, res);
    //     }
    //   });
    // },
    uploadSectionFile(param) {
      var fileObj = param.file;
      var form = new FormData();
      form.append("file", fileObj);

      // 检查文件类型并设置相应的type值
      if (fileObj.type.startsWith("video/")) {
        form.append("type", 402); // 对于视频文件
      } else {
        form.append("type", 101); // 对于图片文件
      }

      uploadFile1(form).then(res => {
        loadingInstance(Loading).close();
        if (res.status === ERR_OK) {
          // 无论是图片还是视频，都添加到masterImage1数组
          this.productForm.masterImage1.push(res.data);
        } else {
          Error(this, res);
        }
      });
      console.log("After upload, fileList:", this.productForm.masterImage1);
    },
    //	101		//文件类型   101 商品图片 102 供应商营业执照  103 banner图    104商品分类logo
    uploadManyFile(param) {
      var fileObj = param.file;
      var form = new FormData();
      form.append("file", fileObj);
      form.append("type", 101);
      uploadFile1(form).then(res => {
        loadingInstance(Loading).close();
        if (res.status === ERR_OK) {
          this.productForm.detailsImages.push(res.data);
        } else {
          Error(this, res);
        }
      });
    },
    uploadSingleProductFile(param) {
      var fileObj = param.file;
      var form = new FormData();
      form.append("file", fileObj);
      form.append("type", 101);
      uploadFile1(form).then(res => {
        loadingInstance(Loading).close();
        if (res.status === ERR_OK) {
          this.singleProduct.images.push(res.data);
        } else {
          Error(this, res);
        }
      });
    },
    _getCategory() {
      let param = {};
      loadingInstance(Loading);
      getCategorys(param).then(res => {
        loadingInstance(Loading).close();
        if (res.status === ERR_OK) {
          if (res.data.length > 0) {
            //处理分类结构
            this.categoryOptions = [];
            for (var i = 0; i < res.data.length; i++) {
              let cate = res.data[i];
              let category = {};
              category.value = cate.id;
              category.label = cate.name;
              if (cate.categoryVos != null) {
                let child = [];
                for (var j = 0; j < cate.categoryVos.length; j++) {
                  let cc = {};
                  cc.value = cate.categoryVos[j].id;
                  cc.label = cate.categoryVos[j].name;
                  child.push(cc);
                }
                category.children = child;
              }
              this.categoryOptions.push(category);
            }
            // console.log(this.categoryOptions);
          }
        } else {
          Error(this, res);
        }
      });
    },
    // 商品专区的选择列表
    getPrefecture() {
      getPrefecture().then(res => {
        if (res.status === ERR_OK) {
          this.prefectureOptions = res.data.records;
        } else {
          Error(this, res);
        }
      });
    },
    // 关联品牌的选择列表
    brandCategoryCategory() {
      brandCategoryCategory().then(res => {
        if (res.status === ERR_OK) {
          this.brandCategoryCategoryOptions = res.data;

        } else {
          Error(this, res);
        }
      });
    },
    _getSupplier() {
      let param = {
        current: this.pageNum,
        size: 100
      };
      loadingInstance(Loading);
      getAllSupplier(param).then(res => {
        loadingInstance(Loading).close();
        if (res.status === ERR_OK) {
          this.supplierOptions = res.data.records;
        } else {
          Error(this, res);
        }
      });
    },
    _productSkuList() {
      loadingInstance(Loading);
      productSkuList({ type: 3 }).then(res => {
        loadingInstance(Loading).close();
        if (res.status === ERR_OK) {
          this.baseGoodsList = res.data;
        } else {
          Error(this, res);
        }
      });
    },
    _getLogistics() {
      let param = {
        current: this.pageNum,
        size: 100
      };
      loadingInstance(Loading);
      getLogistics(param).then(res => {
        loadingInstance(Loading).close();
        if (res.status === ERR_OK) {
          this.logisticsOptions = res.data;
        } else {
          Error(this, res);
        }
      });
    },
    // 获取城市
    _getProvince() {
      let param = {};
      loadingInstance(Loading);
      getAllProvince(param).then(res => {
        loadingInstance(Loading).close();
        if (res.status === ERR_OK) {
          this.provinceOptions = res.data;
          if (this.productId != null) {
            this._getProductDetail();
          }
        } else {
          Error(this, res);
        }
      });
    },
    _getRepet(item, vip) {
      let thisRepet = item.repetitionPriceVos.find(s => s.vip == vip) || {};
      return thisRepet.price || 0;
    },
    _getProductDetail() {
      let param = {
        spuId: parseInt(this.productId)
      };
      getProductDetail(param).then(res => {
        loadingInstance(Loading).close();
        if (res.status === ERR_OK) {
          this.productForm = res.data;
          // console.log("9999");
          // console.log(this.productForm);
          // 如果 isPoints 为 null，则将其设置为 0
          if (this.productForm.isPoints === null) {
            this.productForm.isPoints = 0;
          }
          if (this.productForm.isOnePay === null) {
            this.productForm.isOnePay = 0;
          }
          if (this.productForm.isSubsidyRate === null) {
            this.productForm.isSubsidyRate = 0;
          }
          if (this.productForm.isRestock === null) {
            this.productForm.isRestock = 0;
          }
          if (this.productForm.isGiftPkg === null) {
            this.productForm.isGiftPkg = 0;
          }
          this.productForm.isLevel = this.productForm.isLevel + "";
          this.specialSpec = res.data.specialSpec;
          this.isRestock = res.data.isRestock; //是否进入进获区
          this.isPoints = res.data.isPoints; // 商品积分抵扣
          this.isOnePay = res.data.isOnePay; //一元购商品
          this.isSubsidyRate = res.data.isSubsidyRate; //不结算市场管理奖
          this.isRegion = res.data.isRegion; //是否区域产品
          this.isGroup = res.data.isGroup; //是否团购产品
          this.isGiftPkg = res.data.isGiftPkg; //是否为消费礼包
          // console.log(this.isPoints);
          // this.provinceList = this.productForm.provinceList;
          this.cityList = this.productForm.cityList;
          this.countyList = this.productForm.countyList;
          this.streetList = this.productForm.streetList;
          //街道显示的代码
          // if (
          //   this.productForm.streetCode != null &&
          //   this.productForm.streetCode != ""
          // ) {
          //   this.productForm.streetCode = this.productForm.streetCode.split(
          //     ","
          //   );
          // }
          // 省
          if (
            this.productForm.provinceCode != null &&
            this.productForm.provinceCode != ""
          ) {
            this.productForm.provinceCode = this.productForm.provinceCode.split(
              ","
            );
          }
          // 市
          if (
            this.productForm.cityCode != null &&
            this.productForm.cityCode != ""
          ) {
            this.productForm.cityCode = this.productForm.city.split(",");
          }
          // 区
          if (
            this.productForm.countyCode != null &&
            this.productForm.countyCode != ""
          ) {
            this.productForm.countyCode = this.productForm.county.split(",");
          }
          // 接收
          this.skuBos = res.data.skuVos;
          res.data.areaFees = []; //首先对 "res.data.areaFees" 进行了初始化操作，将其赋值为空数组 []。如果在整个代码块执行前需要清空或重置 "res.data.areaFees"，
          if (this.skuBos) {
            this.skuBos.forEach(item => {
              if (item.areaFees !== null) {
                item.areaFees.forEach(data => {
                  res.data.areaFees.push(data);
                });
              }
            });
            // console.log(res.data.areaFees);
          }
          if (res.data.skuVos && res.data.skuVos.length > 0) {
            this.fxPrices = res.data.skuVos.map(item => {
              return {
                skuId: item.id,
                title: item.title,
                price: this._getRepet(item, "-1"),
                price0: this._getRepet(item, "0"),
                price1: this._getRepet(item, "1"),
                price2: this._getRepet(item, "2"),
                price3: this._getRepet(item, "3"),
                price4: this._getRepet(item, "4")
              };
            });
          }
          if (res.data.areaFees) {
            this.areaFees = res.data.areaFees;
            for (let i = 0; i < this.areaFees.length; i++) {
              let province = this.areaFees[i];
              province.provinces = province.codes
                .map((item, idx) => {
                  var value = this.provinceOptions.find(function(ele, index) {
                    return ele.code == item;
                  });
                  return value.name;
                })
                .toString();
            }
          }
          // this.pcc = res.data.price;
          // console.log(res.data.minPrice,'商城价');
          // console.log(res.data.skuVos[0].repetitionPriceVos[0].price,'非会员');
          // console.log(res.data.skuVos[0].repetitionPriceVos[1].price,'普通会员');
          // console.log(res.data.skuVos[0].repetitionPriceVos[2].price,'vip会员');
          // console.log(res.data.skuVos[0].repetitionPriceVos[3].price,'银行卡会员');
          // console.log(res.data.skuVos[0].repetitionPriceVos[4].price,'金卡会员');
          // console.log(res.data.skuVos[0].repetitionPriceVos[5].price,'钻卡会员');
          // Math.round(price * (1-(this.active-0)/100 * 1)) =
          // 反推复消价格
          if (
            res.data.skuVos[0].repetitionPriceVos[1] &&
            res.data.skuVos[0].repetitionPriceVos[2] &&
            res.data.skuVos[0].repetitionPriceVos[1].price &&
            res.data.skuVos[0].repetitionPriceVos[2].price
          ) {
            this.active = Math.round(
              (1 -
                res.data.skuVos[0].repetitionPriceVos[2].price /
                  res.data.skuVos[0].repetitionPriceVos[1].price) *
                100
            );
          }

          // this.price = res.data.skuVos[0].repetitionPriceVos[0].price;
          // this.price = res.data.minPrice;
          // this.price0 = res.data.skuVos[0].repetitionPriceVos[1].price;
          // this.price1 = res.data.skuVos[0].repetitionPriceVos[2].price;
          // this.price2 = res.data.skuVos[0].repetitionPriceVos[3].price;
          // this.price3 = res.data.skuVos[0].repetitionPriceVos[4].price;
          // this.price4 = res.data.skuVos[0].repetitionPriceVos[5].price;
          this.productForm.skuVos = null;
          this.productForm.homePage = this.productForm.homePage + "";
          this.productForm.newHomePage = this.productForm.newHomePage + "";
          this.productForm.exchange = this.productForm.exchange + "";
          this.productForm.refundable = this.productForm.refundable + "";
          this.productForm.isDistributor = this.productForm.isDistributor + "";
          this.productForm.isPurchase = this.productForm.isPurchase + "";
          this.productForm.type = this.productForm.type + "";
          // this.fileList = [];
          // this.fileList.push({
          //   name: res.data.masterImage,
          //   url: res.data.masterImage
          // });
          // this.fileList1 = [];
          // for (let i = 0; i < res.data.detailsImages.length; i++) {
          //   let imgUrl = res.data.detailsImages[i];
          //   this.fileList1.push({
          //     name: imgUrl,
          //     url: imgUrl
          //   });
          // }
          this.fileList3 = [];
          this.fileList3.push({
            name: res.data.video,
            url: res.data.video
          });
          this.fileList4 = [];
          this.fileList4.push({
            name: res.data.videoImage,
            url: res.data.videoImage
          });
          this.fileList = [];
          if (res.data.masterImage1 && res.data.masterImage1.length > 0) {
            res.data.masterImage1.forEach(imgUrl => {
              this.fileList.push({
                name: imgUrl,
                url: imgUrl
              });
            });
          }

          this.fileList1 = [];
          if (res.data.detailsImages && res.data.detailsImages.length > 0) {
            res.data.detailsImages.forEach(imgUrl => {
              this.fileList1.push({
                name: imgUrl,
                url: imgUrl
              });
            });
          }
          this.categorySelect = [res.data.cid1, res.data.cid2];
        } else {
          Error(this, res);
        }
      });
    },

    // 提交
    onSubmit() {
      if (this.skuBos.length < 1) {
        alert("请添加商品参数");
        return;
      }
      // 计次商品单位校验
      if (this.productForm.isNumGoods === 1 && this.productForm.numGoodsUnit > 0) {
        for (let sku of this.skuBos) {
          if (!sku.goodsNum || sku.goodsNum % this.productForm.numGoodsUnit !== 0) {
            this.$message.error('SKU商品次数必须为单位数量的整数倍');
            return;
          }
        }
      }
      // 判断是否进入进货区
      if (this.productForm.isRestock === 1) {
        // 计算 isBaseSku 为 1 的 skuBos 元素数量
        const baseSkuCount = this.skuBos.reduce(
          (count, sku) => count + (sku.isBaseSku === 1 ? 1 : 0),
          0
        );

        // 验证是否有且仅有一个 isBaseSku 为 1 的元素
        if (baseSkuCount !== 1) {
          alert("必须有且只有一个商品是基础产品");
          return;
        }
      }

      this.productForm.homePage = parseInt(this.productForm.homePage);
      this.productForm.newHomePage = parseInt(this.productForm.newHomePage);
      this.productForm.exchange = parseInt(this.productForm.exchange);
      this.productForm.refundable = parseInt(this.productForm.refundable);
      this.productForm.isNumGoods = parseInt(this.productForm.isNumGoods);

      this.productForm.skuBos = this.skuBos;

      // console.log("skuBos----", this.productForm.skuBos);
      // // 检查 this.productForm.isNumGoods 是否不等于1，如果不等于1，则排除 perPrice 字段
      // if (this.productForm.isNumGoods === 0) {
      //   delete this.productForm.skuBos.perPrice;
      // }
      // 检查 this.productForm.isNumGoods 是否不等于1，如果不等于1，则排除 perPrice 字段

      // if (this.productForm.isNumGoods === 0) {
      //   console.log(this.productForm.isNumGoods);
      //   this.productForm.skuBos.forEach(sku => {
      //     delete sku.perPrice;
      //   });
      // }
      //街道注释掉
      // if (this.productForm.streetCode != null) {
      //   this.productForm.streetCode = this.productForm.streetCode.toString();
      // }
      // 如果 provinceCode 不是 null，它执行一个操作，将 provinceCode 转换为字符串。
      if (this.productForm.provinceCode != null) {
        this.productForm.provinceCode = this.productForm.provinceCode.toString();
      }
      if (this.productForm.cityCode != null) {
        this.productForm.cityCode = this.productForm.cityCode.toString();
      }
      if (this.productForm.countyCode != null) {
        this.productForm.countyCode = this.productForm.countyCode.toString();
      }
      // 当添加商品时执行
      if (this.productId == null) {
        if (this.productForm.streetCode != null) {
          this.productForm.streetCode = this.productForm.countyCode.toString();
        }
      }
      // console.log(this.areaFees);
      let b = [];
      // 删除外层的数据
      this.areaFees.map((item, index, arr) => {
        if (
          item.hasOwnProperty("specialSpecValue") &&
          item.specialSpecValue !== null
        ) {
          b.push(index);
        }
      });
      for (var i = b.length - 1; i >= 0; i--) {
        this.areaFees.splice(b[i], 1);
      }
      this.productForm.areaFees = this.areaFees;
      this.removeIds.map(item => {
        this.productForm.skuBos.push({
          id: item
        });
      });
      this.productForm.specialSpec = this.specialSpec;
      // 检查 this.productForm.isNumGoods 是否不等于1，如果不等于1，则排除 perPrice 字段
      if (this.productForm.isNumGoods !== 1) {
        delete this.productForm.perPrice;
      }
      // 根据产品 ID 判断是添加还是更新产品
      loadingInstance(Loading);
      if (this.productId != null) {
        // console.log(this.productForm);
        updateProduct(this.productForm).then(res => {
          loadingInstance(Loading).close();
          if (res.status === ERR_OK) {
            Success(this, res);
            // 这个记得一会儿打开
            this.$router.push({
              path: "/product"
            });
          } else {
            this.reset();
            Error(this, res);
          }
        });
      } else {
        // console.log(this.productForm);
        addProduct(this.productForm).then(res => {
          loadingInstance(Loading).close();
          if (res.status === ERR_OK) {
            Success(this, res);
            this.$router.push({
              path: "/product"
            });
          } else {
            this.reset();
            Error(this, res);
          }
        });
      }
    },
    // onSubmit() {
    //   if (this.skuBos.length < 1) {
    //     alert("请添加商品参数");
    //   } else {
    //     this.productForm.homePage = parseInt(this.productForm.homePage);
    //     this.productForm.newHomePage = parseInt(this.productForm.newHomePage);
    //     this.productForm.exchange = parseInt(this.productForm.exchange);
    //     this.productForm.refundable = parseInt(this.productForm.refundable);
    //     this.productForm.isNumGoods = parseInt(this.productForm.isNumGoods);

    //     this.productForm.skuBos = this.skuBos;

    //     // console.log("skuBos----", this.productForm.skuBos);
    //     // // 检查 this.productForm.isNumGoods 是否不等于1，如果不等于1，则排除 perPrice 字段
    //     // if (this.productForm.isNumGoods === 0) {
    //     //   delete this.productForm.skuBos.perPrice;
    //     // }
    //     // 检查 this.productForm.isNumGoods 是否不等于1，如果不等于1，则排除 perPrice 字段

    //     // if (this.productForm.isNumGoods === 0) {
    //     //   console.log(this.productForm.isNumGoods);
    //     //   this.productForm.skuBos.forEach(sku => {
    //     //     delete sku.perPrice;
    //     //   });
    //     // }
    //     //街道注释掉
    //     // if (this.productForm.streetCode != null) {
    //     //   this.productForm.streetCode = this.productForm.streetCode.toString();
    //     // }
    //     // 如果 provinceCode 不是 null，它执行一个操作，将 provinceCode 转换为字符串。
    //     if (this.productForm.provinceCode != null) {
    //       this.productForm.provinceCode = this.productForm.provinceCode.toString();
    //     }
    //     if (this.productForm.cityCode != null) {
    //       this.productForm.cityCode = this.productForm.cityCode.toString();
    //     }
    //     if (this.productForm.countyCode != null) {
    //       this.productForm.countyCode = this.productForm.countyCode.toString();
    //     }
    //     // console.log(this.areaFees);
    //     let b = [];
    //     // 删除外层的数据
    //     this.areaFees.map((item, index, arr) => {
    //       if (
    //         item.hasOwnProperty("specialSpecValue") &&
    //         item.specialSpecValue !== null
    //       ) {
    //         b.push(index);
    //       }
    //     });
    //     for (var i = b.length - 1; i >= 0; i--) {
    //       this.areaFees.splice(b[i], 1);
    //     }
    //     this.productForm.areaFees = this.areaFees;
    //     this.removeIds.map(item => {
    //       this.productForm.skuBos.push({
    //         id: item
    //       });
    //     });
    //     this.productForm.specialSpec = this.specialSpec;
    //     // 检查 this.productForm.isNumGoods 是否不等于1，如果不等于1，则排除 perPrice 字段
    //     if (this.productForm.isNumGoods !== 1) {
    //       delete this.productForm.perPrice;
    //     }
    //     loadingInstance(Loading);
    //     if (this.productId != null) {
    //       // console.log(this.productForm);
    //       updateProduct(this.productForm).then(res => {
    //         loadingInstance(Loading).close();
    //         if (res.status === ERR_OK) {
    //           Success(this, res);
    //           // 这个记得一会儿打开
    //           this.$router.push({
    //             path: "/product"
    //           });
    //         } else {
    //           this.reset();
    //           Error(this, res);
    //         }
    //       });
    //     } else {
    //       // console.log(this.productForm);
    //       addProduct(this.productForm).then(res => {
    //         loadingInstance(Loading).close();
    //         if (res.status === ERR_OK) {
    //           Success(this, res);
    //           this.$router.push({
    //             path: "/product"
    //           });
    //         } else {
    //           this.reset();
    //           Error(this, res);
    //         }
    //       });
    //     }
    //   }
    // },
    reset() {
      this.productForm.homePage = this.productForm.homePage + "";
      this.productForm.newHomePage = this.productForm.newHomePage + "";
      this.productForm.exchange = this.productForm.exchange + "";
      this.productForm.refundable = this.productForm.refundable + "";
    },
    // 获取门店列表
    _getStoreList() {
      loadingInstance(Loading);
      getStoreList().then(res => {
        loadingInstance(Loading).close();
        if (res.status === ERR_OK) {
          this.storeList = res.data;
        } else {
          Error(this, res);
        }
      });
    },
    updateValues1(price) {
      // 根据一定比例计算第二个输入框的值
      return parseFloat(
        (price * (1 - ((this.active - 0) / 100) * 1)).toFixed(2)
      ); // 以0.5倍的比例计算
    },
    updateValues2(price) {
      // 根据一定比例计算第二个输入框的值
      return parseFloat((price * (1 - (this.active * 2 - 0) / 100)).toFixed(2)); // 以0.5倍的比例计算
    },
    updateValues3(price) {
      // 根据一定比例计算第二个输入框的值
      return parseFloat((price * (1 - (this.active * 3 - 0) / 100)).toFixed(2)); // 以0.5倍的比例计算
    },
    updateValues4(price) {
      // 根据一定比例计算第二个输入框的值
      return parseFloat((price * (1 - (this.active * 4 - 0) / 100)).toFixed(2)); // 以0.5倍的比例计算
    }
  },
  computed: {
    // updateValues1(price) {
    //   // 根据一定比例计算第二个输入框的值
    //   return Math.round(this.price * (1-(this.active-0)/100 * 1)); // 以0.5倍的比例计算
    // },
    // updateValues2() {
    //   // 根据一定比例计算第二个输入框的值
    //   return Math.round(this.price0 * (1-(this.active-0)/100 * 2)) ; // 以0.5倍的比例计算
    // },
    // updateValues3() {
    //   // 根据一定比例计算第二个输入框的值
    //   return Math.round(this.price0 * (1-(this.active-0)/100 * 3)); // 以0.5倍的比例计算
    // },
    // updateValues4() {
    //   // 根据一定比例计算第二个输入框的值
    //   return Math.round(this.price0 * (1-(this.active-0)/100 * 4)); // 以0.5倍的比例计算
    // },

    qtupdateValues1() {
      // 根据一定比例计算第二个输入框的值
      return (Number(this.productForm.qtRate) * 0.9).toFixed(2); // 以0.9倍的比例计算
    },
    qtupdateValues2() {
      // 根据一定比例计算第二个输入框的值
      return (Number(this.productForm.qtOneRate) * 0.9).toFixed(2); // 以0.9倍的比例计算
    },
    qtupdateValues3() {
      // 根据一定比例计算第二个输入框的值
      return (Number(this.productForm.qtTwoRate) * 0.9).toFixed(2); // 以0.9倍的比例计算
    },
    qtupdateValues4() {
      // 根据一定比例计算第二个输入框的值
      return (Number(this.productForm.qtThreeRate) * 0.9).toFixed(2); // 以0.9倍的比例计算
    },
    qtupdateValues5() {
      // 根据一定比例计算第二个输入框的值
      return (Number(this.productForm.qtFourRate) * 0.9).toFixed(2); // 以0.9倍的比例计算
    }
  }
};
</script>
<style scoped>
.add-product {
  height: fit-content;
  margin-left: 50px;
  margin-top: 30px;
  margin-bottom: 30px;
  box-sizing: border-box;
}

.product-title {
  width: 100%;
  display: inline-block;
  float: left;
  font-weight: bold;
  margin-top: 10px;
  margin-bottom: 10px;
  font-size: 18px;
  color: #333333;
}

.el-form-item {
  margin-left: 10px;
}
</style>
<style>
.el-tag + .el-tag {
  margin: 5px;
}

.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}

.input-new-tag {
  width: 100px;
  margin-left: 10px;
  vertical-align: bottom;
}

.add-product .el-input {
  width: 250px;
  margin-right: 10px;
  display: inline-block;
  float: left;
}

.add-product .el-button {
  width: 120px;
  display: inline-block;
}
.activestyle {
  margin-bottom: 20px;
}
.graytit {
  font-size: 12px;
  color: gray;
}
</style>



// WEBPACK FOOTER //
// src/components/product/addProduct.vue